<template>
  <div>
    <div style='padding: 15px' class="table-page-search-wrapper">
      <a-form layout='inline'>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='4'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'depositDate')" >
              <a-range-picker
                style='width: 240px'
                v-model='queryParam.dateDt'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='4'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'telemarketerName')">
              <a-select
                style='width: 200px'
                v-model='queryParam.userIds'
                mode='multiple'
              >
                <a-select-option v-for='item in userNameList' :key='item.userId'>
                  {{ item.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='4'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'mobile')">
              <a-input style='width: 200px'
                placeholder="请输入手机号"
                v-model="queryParam.mobile"/>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='4'>
<!--            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'callStatus')">-->
<!--              <a-select default-value='0' style='width: 120px' v-model='queryParam.telStatus'>-->
<!--                <a-select value='0'>未拨打</a-select>-->
<!--                <a-select value='1'>已接通</a-select>-->
<!--                <a-select value='2'>未接通</a-select>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'callStatus')">
              <dict-select
                style='width: 200px'
                v-model='queryParam.telStatus'
                :dict-code='DICT_CODE.TelMarket_Status'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='4'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'isRegist')">
              <a-select
                style='width: 240px'
                v-model='queryParam.isRegist'
              >
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  否
                </a-select-option>
                <a-select-option value="1">
                  是
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='4'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'isApply')">
              <a-select
                style='width: 240px'
                v-model='queryParam.isApply'
              >
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  否
                </a-select-option>
                <a-select-option value="1">
                  是
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='4'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'isAudit')">
              <a-select
                style='width: 240px'
                v-model='queryParam.isAudit'
              >
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  否
                </a-select-option>
                <a-select-option value="1">
                  是
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='4'>
            <a-button type='primary' @click='searchCollectionTelMarketInfos' icon='search'>
              {{ $t('search') }}
            </a-button>
            <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}
            </a-button>
            <a-button type='primary' @click="downLoadData()" icon='download'
                          style='margin-left: 8px'>{{ $t('exportFile')
                  }}</a-button>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        size='middle'
        :columns='columns'
        :data-source='dataSource'
        :loading='loading'
        :pagination='ipagination'
        bordered
        @change='handleTableChange'
      >
        <Dict slot='telStatusSlot' slot-scope='text' :dict-code='DICT_CODE.TelMarket_Status' :value='text' />

      </a-table>
    </div>
  </div>

</template>

<script>
import { getUserNamelist, queryTelMarketList } from '@/webpublicapi/collection'
import moment from 'moment'
import exportFile from '@/api/exportFile'
import { exportFileByPost } from '@/api/exportFile'
import DictSelect from '../modules/DictSelect'
import Dict from '@/views/webpublic/modules/Dict.vue'

const I18N_KEY = {
  COLLECTION: 'collection.'
}

export default {
  name: 'CollectionTelMarket'
  ,
  components: { Dict, DictSelect },
  data() {
    return {
      I18N_KEY,
      loading: false,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      userNameList:[],
      //查询条件
      queryParam: {
        userIds: [],
        dateDt: [moment().add('days', -0), moment().add('days', 0)],
        telStatus: '',
        mobile: "",
        isRegist: "",
        isApply: "",
        isAudit: ""
      }


      //回显内容
      , dataSource: []
    }
  }

  , computed: {
    columns() {
      return [
        //title
        {
          title: this.$t(I18N_KEY.COLLECTION + 'depositDate'),
          align: 'left',
          dataIndex: 'createTime'
        },
        {
          title: this.$t(I18N_KEY.COLLECTION + 'telemarketerName'),
          align: 'left',
          dataIndex: 'userName'
        },
        {
          title: this.$t(I18N_KEY.COLLECTION +'dialNumber'),
          align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: this.$t(I18N_KEY.COLLECTION +'dialDate'),
          align: 'left',
          dataIndex: 'telTime'
        },
        {
          title: this.$t(I18N_KEY.COLLECTION + 'callStatus'),
          align: 'left',
          dataIndex: 'telStatus',
          scopedSlots: { customRender: 'telStatusSlot' }

        },
        {
          title: this.$t(I18N_KEY.COLLECTION + 'isRegist'),
          align: 'left',
          dataIndex: 'isRegister',
          customRender: (text) => {
            return text === 1 ? '是' : '否'
          }

        },
        {
          title: this.$t(I18N_KEY.COLLECTION + 'isApply'),
          align: 'left',
          dataIndex: 'isApply',
          customRender: (text) => {
            return text === 1 ? '是' : '否'
          }

        },
        {
          title: this.$t(I18N_KEY.COLLECTION + 'isAudit'),
          align: 'left',
          dataIndex: 'isAudit',
          customRender: (text) => {
            return text === 1 ? '是' : '否'
          }

        }
      ]
    }
  }
  //初始化方法
  , created() {
    this.loadData(1)
    getUserNamelist().then(res => {
      console.log('res',res.data)
      this.userNameList = res.data || []
    })
  }
  //自定义方法
  , methods: {
    //导出
    async downLoadData () {
      var params = this.getQueryParams()// 查询条件
      this.loading = true;
      try {
        const result = await exportFileByPost(
          '/api/web/webpublic/collectionTelMarket/exportTelInfoListExcel',
          params,
          //"CollectionTelMarket" + params.createTimeStart  + params.createTimeEnd +'.xlsx',
          "CollectionTelMarket.xlsx"
        );
        if (result instanceof Error) {
          this.$message.error(result.message);
        }
      } catch(error) {
          this.$message.error(error.message);
      } finally {
            // 无论成功还是失败，都设置 loading 为 false
            this.loading = false;
        }
    },
    //初始化参数
    getQueryParams() {
      console.log('queryParam',this.queryParam)
      const { dateDt } = this.queryParam

      const data = {
        ...this.queryParam,
        createTimeStart: dateDt && this.transformTime(dateDt[0]),
        createTimeEnd: dateDt && this.transformTime(dateDt[1])
      }
      console.log('data',data)
      delete data.dateDt
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      data.telStatus = this.queryParam.telStatus
      data.userIds = this.queryParam.userIds
      console.log('传给后端的数据',data)
      return data
    },
    //格式化日期
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    //重置查询条件
    searchReset() {
      var that = this
      that.queryParam.telStatus = ''
      that.queryParam.dateDt = [moment().add('days', -0), moment().add('days', 0)]
      that.queryParam.userIds=[]
      that.queryParam.mobile="",
      that.queryParam.isRegist="",
      that.queryParam.isApply="",
      that.queryParam.isAudit="",
      that.loadData()
    },

    //查询列表方法
    searchCollectionTelMarketInfos() {
      console.log('查询电销信息列表')
      this.loadData(1)
    },
    loadData(arg) {
      //默认加载首页数据
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()
      queryTelMarketList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.loadData()
    }
  }
}
</script>


<style scoped lang='less'>
@import "~@/assets/less/common.less";
</style>